import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class DataServices {
  constructor(){}

  private validUserLogged = new Subject();
  public validUserLogged$ = this.validUserLogged.asObservable();

  private userIdleSession = new BehaviorSubject<any>(null);
  public userIdleSession$ = this.userIdleSession.asObservable();

  private translationJson = new BehaviorSubject<any>(null);
  public translationJson$ = this.translationJson.asObservable();

  setValidUserLogged(data: boolean){
    this.validUserLogged.next(data)
  }

  setUserIdleSession(data: {sessionTimeOut: number; countDown: number}){
    this.userIdleSession.next(data)
  }

  setTranslation(data: any){
    this.translationJson.next(data);
  }
}
